import React from "react";
import { ActionCreator } from "typescript-fsa";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";

import { WaIcon } from "@ui/WaIcon";

interface ButtonProps {
    onClick?: React.MouseEventHandler<any>;
    href?: string;
}

export interface LogoutButtonOwnProps extends React.Props<{}> {
    tag?: string | React.ComponentType<ButtonProps>;
}

export interface LogoutButtonDispatchProps {
    logout: ActionCreator<{}>;
}

type Props = LogoutButtonOwnProps & LogoutButtonDispatchProps;

export class LogoutButton extends React.Component<Props> {
    private onClick = (event: React.MouseEvent<ButtonProps>) => {
        event.preventDefault();

        if (this.props.logout != null) {
            this.props.logout({});
        }
    }

    public render() {
        let Tag: string | React.ComponentType<ButtonProps> = Button;
        if (this.props.tag != null) {
            Tag = this.props.tag;
        }

        return (
            <Tag onClick={this.onClick} href="#">
                <WaIcon name="logout"/>
                <FormattedMessage id="auth.action.logout"
                    defaultMessage="Log out" />
            </Tag>
        );
    }
}
